module.exports = __webpack_public_path__ + "images/serene-footer__mj7RR.png";